import React from 'react'
import { PRIVACY_POLICY_LINK } from 'root-constants'
import { eventLogger } from 'services/eventLogger.service'
import { useTranslation } from 'react-i18next'
import { OuterLink } from 'components/OuterLink'

export const PrivacyPolicyLink: React.FC = () => {
  const { t } = useTranslation()

  return (
    <OuterLink
      href={PRIVACY_POLICY_LINK}
      onClick={() => eventLogger.logPrivacyPolicyClicked()}
    >
      {t('commonComponents.privacyPolicy')}
    </OuterLink>
  )
}
